import { Component, OnInit, ChangeDetectorRef, Input, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { SharedService } from '../../../shared/sharedServices/shared.service';
import { HecResponse } from '../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { NgForm, FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { QuestionnaireComponent } from '../../../shared/shared-components/modal/questionnaire/questionnaire.component';
import { EmploymentDetailsService } from './employment-details.service';
import { decrypt, encrypt } from '../../../utilities/utilityFunctions';
import { Router } from '@angular/router';
import { LoaderService } from '../../../shared/sharedServices/loader.service';
import { GoogleAnalyticsService } from '../../../shared/sharedServices/google-analytics.service';
import { UploadAdditionalDocumentsService } from '../../../shared/shared-components/upload-additional-documents/services/upload-additional-documents.service';
import { EmploymentFormService } from '../../../shared/shared-components/employment-form/services/employment-form.service';
import { AttestationModel } from '../../shared-models/attestationModel';
import { AppFormDataService } from '../../sharedServices/app-form-data.service';
import { EligibilityModel } from '../../shared-models/eligibility-model';
@Component({
	selector: 'kt-shared-employment-details',
	templateUrl: './employment-details.component.html',
	styleUrls: ['./employment-details.component.scss']
})
export class EmploymentDetailsComponent implements OnInit, OnDestroy {
	public loader: boolean = false;
	public commentsList: Array<any>;
	public formViewType: any;
	public educationDetailsData: any = [];
	public educationDetailGridData: any = [];
	public viewform: boolean = false;
	public isAlertVisible: boolean = false;
	public alertClass: string;
	public alertIcon: string;
	public alertMsgValue: string;
	public dateError: string = '';
	public educationDetailsGridDetails: any = [];
	public selectedEducation: any;
	public isEductaionSelected: boolean = false;
	public commonProfileId: string;
	@Output() educationData = new EventEmitter();
	public eduForm: FormGroup;
	@Input('dropdownValuesForDas') dropdownValuesForDas: any;
	@Input('dropdownList') dropdownList: any;
	public formType: string = 'das';
	public alertType: string;
	public formView: string = '';
	public empFormDropdowns: any = [];
	@Input('dasApplicationData') dasApplicationData: AttestationModel = new AttestationModel();
	@Output() updateDasAppData = new EventEmitter();
	@Output() nextComponent = new EventEmitter();
	@Output() prevComponent = new EventEmitter();
	@Input('processAcronym') processAcronym: string;
	constructor(private sharedServices: SharedService, private cdr: ChangeDetectorRef, private fb: FormBuilder, private gaService: GoogleAnalyticsService,
		private router: Router, private loaderService: LoaderService, private appFormDataService: AppFormDataService,
		private matDialog: MatDialog, private educationServices: EmploymentDetailsService,
		public _snackBar: MatSnackBar, private uploadAdditionalService: UploadAdditionalDocumentsService, private empDetailsService: EmploymentFormService) {
		if (localStorage.getItem('emp')) {
			this.selectedEducation = JSON.parse(decrypt(localStorage.getItem('emp')));
		}
		let data = decrypt(localStorage.getItem('esp-profile-details'));
		data = JSON.parse(data);
		this.commonProfileId = data['profileId'];
		this.createEducationForm();
	}
	async ngOnInit() {
		window.scroll(0, 0)
		this.gaService.setPage('/form', 'EmpSP Page');
		this.formView = this.appFormDataService.formView;
		if (this.dasApplicationData && this.dasApplicationData.dasApplicationDto) await this.getDasComments(this.dasApplicationData.dasApplicationDto.id)
		if (this.appFormDataService.isAdmin) {
			await this.getEmpInfoDetailsAdmin(this.appFormDataService.application.commonProfileId);
		}
		else {
			this.getEmpDetails();
			this.getEmpInfoDetails();
		}
	}
	ngOnDestroy() {
		this.appFormDataService.formView = undefined;
		this.appFormDataService.applicationId = undefined;
		localStorage.removeItem('emp');
	}
	private createEducationForm(): void {
		this.eduForm = this.fb.group({
			eduDtoList: this.fb.array([]),
		})
	}
	public getEducationList(): any {
		return this.eduForm.controls.eduDtoList['controls'];
	}
	public addNewEdu(data): void {
		const eduValues = this.eduForm.controls.eduDtoList as FormArray;
		let newRow = this.fb.group({
			isChecked: new FormControl(),
			eduId: new FormControl(data.educationId ? data.educationId : null),
			eduHistoryId: new FormControl(data.eduationHistoryId ? data.eduationHistoryId : null),
			universityName: new FormControl(data.universityName ? data.universityName : ''),
			degreeProgramName: new FormControl((data.countryId == 1) ? data.degreeProgramName : data.otherProgramTitle)
		});
		eduValues.push(newRow);
	}
	public deleteEducationRow(eduInd): void {
		const eduForm = this.eduForm.controls.eduDtoList as FormArray;
		eduForm.removeAt(eduInd);
		this.eduForm.value.eduDtoList--;
	}
	public getEmpDetails() {
		for (let i = 0; i < this.educationDetailGridData.length; i++) {
			this.deleteEducationRow(0);
		}
		this.cdr.detectChanges();
		this.sharedServices.getEmploymentDetails().subscribe(
			(res: HecResponse) => {
				this.educationDetailGridData = [];
				this.cdr.detectChanges();
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.empFormDropdowns = res.data.formDto;
				}
			},
			(err) => {
			}
		)
	}
	public getEmpInfoDetails() {
		for (let i = 0; i < this.educationDetailsGridDetails.length; i++) {
			this.deleteEducationRow(i);
		}
		this.loader = true;
		this.loaderService.setValue(this.loader)
		this.cdr.detectChanges();

		this.sharedServices.getEmploymentInfoDetails().subscribe(
			(res: HecResponse) => {
				this.educationDetailGridData = [];
				this.educationDetailsGridDetails = [];
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cdr.detectChanges();
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					if (res.data.profileDto) this.educationDetailsGridDetails = res.data.profileDto.employmentHistoryDtos;

					for (let i = 0; i < this.educationDetailsGridDetails.length; i++) {
						this.educationDetailGridData.push(this.educationDetailsGridDetails[i]);
						this.getEmployerName(this.educationDetailsGridDetails[i]);
						this.addNewEdu(this.educationDetailsGridDetails[i])
					}
					if (this.selectedEducation) {
						for (let i = 0; i < this.educationDetailGridData.length; i++) {
							if (this.selectedEducation.employmentId == this.educationDetailGridData[i].employmentId) {
								this.eduForm.controls.eduDtoList['controls'][i].controls.isChecked.patchValue(true);
							}
						}
					}
				}

				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cdr.detectChanges();
			},
			(err) => {
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cdr.detectChanges();
			}
		)
		if (this.formView == 'view') {
			setTimeout(() => {
				this.eduForm.disable()
				this.eduForm.controls.eduDtoList.disable();
			}, 1000);
		}
		setTimeout(() => {
			this.educationDetailGridData.forEach((element, index) => {
				if (element.countryId != 1 && element.isCurrentEnrolment) {
					setTimeout(() => {
						this.eduForm.controls.eduDtoList['controls'][index].controls.isChecked.disable();
					}, 500);
				}
			});
		}, 500);
	}
	public getEmpInfoDetailsAdmin(id) {
		for (let i = 0; i < this.educationDetailsGridDetails.length; i++) {
			this.deleteEducationRow(i);
		}
		this.loader = true;
		this.loaderService.setValue(this.loader)
		this.cdr.detectChanges();

		this.sharedServices.getPersonalDetailsAdmin(id).subscribe(
			(res: HecResponse) => {
				this.educationDetailGridData = [];
				this.educationDetailsGridDetails = [];
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cdr.detectChanges();
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					if (res.data.employment) this.educationDetailsGridDetails = res.data.employment;

					for (let i = 0; i < this.educationDetailsGridDetails.length; i++) {
						this.educationDetailGridData.push(this.educationDetailsGridDetails[i]);
						this.getEmployerName(this.educationDetailsGridDetails[i]);
						this.addNewEdu(this.educationDetailsGridDetails[i])
					}
					if (this.selectedEducation) {
						for (let i = 0; i < this.educationDetailGridData.length; i++) {
							if (this.selectedEducation.employmentId == this.educationDetailGridData[i].employmentId) {
								this.eduForm.controls.eduDtoList['controls'][i].controls.isChecked.patchValue(true);
							}
						}
					}
				}

				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cdr.detectChanges();
			},
			(err) => {
				this.loader = false;
				this.loaderService.setValue(this.loader);
				this.cdr.detectChanges();
			}
		)
		if (this.formView == 'view') {
			setTimeout(() => {
				this.eduForm.disable()
				this.eduForm.controls.eduDtoList.disable();
			}, 1000);
		}
		setTimeout(() => {
			this.educationDetailGridData.forEach((element, index) => {
				if (element.countryId != 1 && element.isCurrentEnrolment) {
					setTimeout(() => {
						this.eduForm.controls.eduDtoList['controls'][index].controls.isChecked.disable();
					}, 500);
				}
			});
		}, 500);
	}
	public async getDasComments(appId): Promise<any> {
		if (appId) {
			try {
				this.loader = true;
				this.loaderService.setValue(this.loader)
				const res = await this.uploadAdditionalService.getDasComments(appId).toPromise()
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.commentsList = [];
					res.data.forEach(element => {
						if (element.degreeId) {
							this.commentsList.push(element);
						}
					});
				} else {
				}
				this.loader = false;
				this.loaderService.setValue(this.loader)
			} catch (err) {
				this.loader = false;
				this.loaderService.setValue(this.loader)
			}
		}
	}
	public goNext() {
		if (this.formView == 'view') {
			this.nextComponent.emit(true);
			if (!this.cdr["destroyed"]) this.cdr.detectChanges();
		}
		else {
			this.checkEligibility()
		}
	}
	public goBack() {
		this.prevComponent.emit(true);
		this.cdr.detectChanges();
	}
	public async openEducationDetails(data, index, type) {
		this.formViewType = type;
		this.educationDetailsData = data;
		this.viewform = true;
		this.cdr.detectChanges();
		if (type == 'view') {
			this._snackBar.open('You\'re in view mode! To exit, please click Cancel button to continue with your Application Form', '', {
				duration: 9500,
				panelClass: ['error-snackbar']
			});
		} else if (type == 'edit') {
			this._snackBar.open('You\'re in edit mode! To exit, please click Cancel button to continue with your Application Form', '', {
				duration: 9500,
				panelClass: ['error-snackbar']
			});
		}
	}
	public deleteEducation(educationData) {
		this.loader = true;
		this.loaderService.setValue(this.loader)
		educationData.activeIndicator = false;
		delete educationData.employerId;
		let payload = educationData;
		this.sharedServices.saveOrUpdateEmployment(payload).subscribe(
			(res: HecResponse) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.getEmpInfoDetails();
				} else {
					this.loader = false;
					this.loaderService.setValue(this.loader)
					this.isAlertVisible = true;
					this.alertType = 'error';
					this.alertMsgValue = 'Error in deleting Employment';
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.loader = false;
				this.loaderService.setValue(this.loader)
				this.isAlertVisible = true;
				this.alertType = 'error';
				this.alertMsgValue = 'Error in deleting Employment';
				this.cdr.detectChanges();
			}
		)
	}
	public getDate(date): any {
		if (!date) return date;
		let convertedDate = new Date(date).toISOString();
		return convertedDate;
	}
	public getCommentDate(date): void {
		return this.sharedServices.getDate(date);
	}
	public addNewEducation() {
		this.formViewType = 'new';
		this.educationDetailsData = [];
		this.viewform = true;
		this.cdr.detectChanges();
		this.cdr.markForCheck();
	}

	public getUpdatedEmp(empStatus) {
		this.viewform = false;
		this.isAlertVisible = true;
		this.formViewType = undefined;
		if (empStatus.id) {
			this.alertType = 'success';
			this.alertMsgValue = 'Employment Update Successfully';
		} else {
			this.alertType = 'success';
			this.alertMsgValue = 'Employment Added Successfully';
		}
		this.getEmpInfoDetails();
		setTimeout(() => {
			this.isAlertVisible = false;
			this.cdr.detectChanges();
		}, 3000)
	}
	public async submitEmployment(type) {
		this.goNext();
	}
	public submitQuestionnaire(): void {
		let payload = this.constructPayload()
		payload.data.dasApplicationDto['isQuestionnaireFilled'] = true;
		this.educationServices.saveApplicationData(payload).subscribe(
			async (res: HecResponse) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					this.updateDasAppData.emit(res.data.dasApplicationDto)
					this.educationData.emit(res.data.dasApplicationDto)
					this.goNext();
				} else {
					this.loader = false;
					this.loaderService.setValue(this.loader)
					this.cdr.detectChanges();
				}
			},
			(err) => {
				this.loader = false;
				this.loaderService.setValue(this.loader)
				this.cdr.detectChanges();
			}
		)
	}
	private constructPayload() {
		localStorage.removeItem('empHistory')
		var dasDegrees = [];
		var educationHistoryDtos = [];
		for (let i = 0; i < this.eduForm.value.eduDtoList.length; i++) {
			if (this.educationDetailGridData[i].educationId == this.eduForm.value.eduDtoList[i].eduId &&
				this.eduForm.value.eduDtoList[i].isChecked) {
				educationHistoryDtos.push(this.educationDetailGridData[i])
				if (this.formView != 'pucaRevision') {
					dasDegrees.push({
						cpEducationHistoryId: this.educationDetailGridData[i].eduationHistoryId,
						nameOnDegree: decrypt(localStorage.getItem('name')),
						exactDegreeTitle: (this.educationDetailGridData && this.educationDetailGridData[i].countryId && this.educationDetailGridData[i].countryId == 1) ? this.educationDetailGridData[i].degreeProgramName : this.educationDetailGridData[i].otherProgramTitle,
						universityNameOnDegree: this.educationDetailGridData[i].universityName && this.educationDetailGridData[i].universityName != 'Other' ? this.educationDetailGridData[i].universityName : this.educationDetailGridData[i].otherUniversity,
						degreeInfo: [],
						id: null
					})
				} else if (this.formView == 'pucaRevision') {
					dasDegrees.push({
						cpEducationHistoryId: this.educationDetailGridData[i].eduationHistoryId,
						nameOnDegree: decrypt(localStorage.getItem('name')),
						exactDegreeTitle: (this.educationDetailGridData && this.educationDetailGridData[i].countryId && this.educationDetailGridData[i].countryId == 1) ? this.educationDetailGridData[i].degreeProgramName : this.educationDetailGridData[i].otherProgramTitle,
						universityNameOnDegree: this.educationDetailGridData[i].universityName && this.educationDetailGridData[i].universityName != 'Other' ? this.educationDetailGridData[i].universityName : this.educationDetailGridData[i].otherUniversity,
						degreeInfo: [],
						educationHistoryDto: this.educationDetailGridData[i],
						id: null
					})
				}
			}
			else {
			}
		}
		if (this.dasApplicationData) {
			for (let j = 0; j < this.dasApplicationData.dasApplicationDto.dasDegrees.length; j++) {
				for (let k = 0; k < dasDegrees.length; k++) {
					if (this.dasApplicationData.dasApplicationDto.dasDegrees[j].cpEducationHistoryId == dasDegrees[k].cpEducationHistoryId) {
						dasDegrees[k].id = this.dasApplicationData.dasApplicationDto.dasDegrees[j].id,
							dasDegrees[k].degreeInfo = this.dasApplicationData.dasApplicationDto.dasDegrees[j].degreeInfo
					}
				}
			}
		}
		let payload = {
			data: {
				dasApplicationDto: {
					commonProfileId: this.commonProfileId,
					id: (this.dasApplicationData && this.dasApplicationData.dasApplicationDto.id) ? this.dasApplicationData.dasApplicationDto.id : null,
					dasDegrees: dasDegrees,
				},
			}
		}
		educationHistoryDtos = educationHistoryDtos.reverse();
		localStorage.setItem('empHistory', encrypt(JSON.stringify(educationHistoryDtos)))
		return payload;
	}
	public getDasFormDate() {
		return new Promise((resolve, reject) => {
			this.loader = true;
			this.loaderService.setValue(this.loader)
			this.educationServices.getPucaFormDetails().subscribe(
				(res: HecResponse) => {
					this.loader = false;
					this.loaderService.setValue(this.loader)
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						if (this.dasApplicationData.dasApplicationDto.isQuestionnaireFilled == undefined) {
							this.ModalComponent(QuestionnaireComponent, res.data.dasQuestionnaireDtoList)
						} else if (this.dasApplicationData.dasApplicationDto.isQuestionnaireFilled) {
							this.goNext();
						}
					} else {
					}
				},
				(err) => {
					this.loader = false;
					this.loaderService.setValue(this.loader)
					this.cdr.detectChanges();
				}
			)
		});
	}
	public ModalComponent(Component, data) {
		const dialogRef = this.matDialog.open(Component, {
			width: '80vw',
			height: '70vh',
			backdropClass: 'custom-scrutiny-popups',
			panelClass: 'custom-scrutiny-popups',
			disableClose: true,
			autoFocus: false,
			data: { questions: data }
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.submitQuestionnaire();
			} else {
				localStorage.setItem('questionnaire', encrypt('return'))
				this.router.navigate(['/dashboard'])
			}
		});
	}
	public cancelEducation(event) {
		if (event == 'cancel') {
			this.formViewType = undefined
			this.viewform = false;
			this.cdr.detectChanges();
		}
	}
	public cancelAttestaion() {
		if (this.appFormDataService.isAdmin) {
			this.router.navigate(['/admin-dashboard/PAK-US-Admnin-Dashboard'])
		}
		else {
			this.router.navigate(['/'])
		}
	}


	private async checkEligibility() {
		let data = decrypt(localStorage.getItem('esp-profile-details'));
		data = JSON.parse(data);
		const res: any = await this.sharedServices.checkEligibility(data['profileId'], this.processAcronym).toPromise();
		if (res.code == 0) {
			let eligibility: EligibilityModel = new EligibilityModel();
			eligibility = res.result;
			if (eligibility && eligibility.isMaxAge) {
				this.nextComponent.emit(true);
				if (!this.cdr["destroyed"]) this.cdr.detectChanges();
			}
			else {
				this.isAlertVisible = true;
				this.alertType = 'error';
				this.alertMsgValue = 'You do not meet the maximum age criteria'
				return false;
			}
		}
	}

	getEmployerName = async (employment) => {
		await this.getUniversityListByCountryAndSector(employment, employment.categoryCodeId);
	}

	public getUniversityListByCountryAndSector(employment, categoryId) {
		return new Promise((resolve, reject) => {
			if (categoryId != undefined) {
				if (employment.employerTypeCode == HEC_CONSTANTS.EMP_ORGANIZATION_TYPE.Academic) {
					this.empDetailsService.getUniversityListByCountryAndSector(employment.employmentCountryId, employment.sectorCode, categoryId).subscribe(
						(res: HecResponse) => {
							if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
								this.dropdownList['empNameList'] = res.data;
								let nameObj = this.dropdownList.empNameList.find(emp => employment.universityId == emp.value);
								employment.universityName = nameObj ? nameObj.label : undefined;
								resolve(this.dropdownList.empNameList);
								this.cdr.detectChanges();
							}
						},
						(err) => {

						}
					)
				}
				else {
					this.empDetailsService.getOrganizationListByCountryAndSector(employment.employmentCountryId, employment.sectorCode, categoryId).subscribe(
						(res: HecResponse) => {
							if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
								for (let i = 0; i < res.data.length; i++) {
									res.data[i]["value"] = res.data[i]["id"];
									res.data[i]["label"] = res.data[i]["organizationName"];
								}
								this.dropdownList.empNameList = res.data;
								let nameObj = this.dropdownList.empNameList.find(emp => employment.organizationId == emp.value);
								employment.organizationName = nameObj ? nameObj.label : undefined;
								resolve(this.dropdownList.empNameList);
								this.cdr.detectChanges();
							}
						},
						(err) => {

						}
					)
				}
			}
		})
			.catch(function (error) {
			})
	}
}
